export const MAX_SEQUENCES_ATTEMPTS = 4;

export const ATTEMPT_ORDINAL_START = 2;
export const INITIAL_BULK_KEY = 'initial';
